import { biLoggerFactory } from 'wix-private';
 
const msid = '5545b997-ef39-438d-a87f-4e2cdcfb6ef8'; //replace the value between quotes with your site msid value
 
/**
 * biGroupsLoggers it's an Object with key:value pair
 * key: represents src of the BI group
 * value: represents the biLogger function for that group
 * */
 
const biGroupsLoggers = {
    
    19: biLoggerFactory('lp', 19, { msid }),
    
}
 
export async function fireBIEvent(src, evid, fields) {
 
    const biLogger = biGroupsLoggers[src];
    try {
        const biEventObject = {
            evid,
            ...fields
        };
        await biLogger.log(biEventObject);
        console.log('BI Event Fired Successfully with ', biEventObject);
    } catch (err) {
        console.error(`Failed to fireBIEvent -err- ${err}`);
    }
}